import "../../challenges/Challenges.css"
import React, { useState,useEffect } from "react";
import "../../myProjects/Myprojects.css"
import { FileUploader } from 'react-drag-drop-files';
import api from "views/auth/Api";
import { message } from 'antd';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FaRegWindowClose } from "react-icons/fa";
import { Link } from "react-router-dom";
import  Loader  from "../../../../components/loader";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";


const fileTypes = ["HTML"];
const MAX_SIZE = 10 * 1024 * 1024; // 10MB

const EditResources = () => {
  const [html, setHtml] = useState(null);
  const [current, setCurrent] = useState('LINK');
  const [resources , setResources] = useState([]); 
   const [htmlLoading, setHtmlLoading] = useState(false);
  const [formInputs , setFormInputs] = useState({
          resourceName:"",
          description:"",
          link:"",
        });
  const [delOpen , setDelOpen] = useState(false)
const [delOneId , setDelOneId] = useState(null)
//   const [editId, setEditId] = useState(null);
  console.log(html,"htmlhtmlhtmlhtml")
  const { id } = useParams();
  const navigate = useNavigate();

          const successAddResources = () => {
           message.success('Your resources added successfully');
          };

    const successHtml = () => {
           message.success('Your HTML uploaded successfully');
          };
          
  const delSuccess = ()=>{
    message.success('Delete done');
  }
  
  const successSaved = () => {
             message.success('Your resources Edited Completely');
            };
  const sizeMessage = () => {
             message.error('File size exceeds the limit of 10MB');
            }
  

     useEffect(() => {
     api.get(`${API_BASE_URL}projects-resources/all/${id}`)
      .then((response) => {  
        if (!response.data) {
          navigate(`/auth/not-found/`);
        }
    setResources(response.data)
      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, [navigate,id]);


const isFormValid = formInputs.resourceName.trim() !== '' && formInputs.description.trim() !== '';

const handleHtmlChange = async (html) => {
      setHtmlLoading(true);
        if (html.size > MAX_SIZE) {
          sizeMessage();
          return;
          }

          const formData = new FormData();
          formData.append('html', html);
          console.log('Uploaded file:', html);
           await api.post(`${API_BASE_URL}attachment/html`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          },
                    })
                            .then(function (response) {
                                  setHtmlLoading(false);
                                  successHtml();
                                  setHtml(response.data);
                            }).catch(error => {
                              console.log("handlesubmit error for blog get ", error)
                            });
        };


    const handleAddRes = (event) => {
    event.preventDefault();
      addResource();
        setHtml(null);
        setFormInputs({
          resourceName:"",
          description:"",
          link:"",
        })

    }
  

      const addResource = async () => {  
       await api.post(`${API_BASE_URL}projects-resources`,{
          name: formInputs.resourceName,
          description: formInputs.description,
          project: id,
          url: current === "LINK" ? formInputs.link : html.url,
          type: current,
        //   html: formInputs,
          })
        .then(function (response) {
                  console.log("handlesubmitffff  ", response.data)
                  successAddResources()
                  setResources(response.data);
              // setData(response.data)
        }).catch(error => {
          console.log("handlesubmit error for blog get ", error)
        });   
          }

 const confirmDel = async (id)=>{
    if (id) {
      setDelOpen(false)
     await api.delete(`${API_BASE_URL}projects-resources/${id}`)
      .then(function (response) {
          setResources(response.data);
          delSuccess();
      }).catch(error => {
        console.log("handlesubmit error for blog ", error)
      });
  }
 }

const delId =(resource)=>{
  setDelOpen(true)
  setDelOneId(resource)
 }


  return (
    <div className="h-fit w-full pt-10"> 
    <h2 className="addLibrary-h2">Edit Project Resources</h2> 
         {resources ? 
                <div className="model3d-cards-add flex-wrap" >
                   {resources.map(resource =>
        <div className="card-container resCardDel"  onClick={()=> {delId(resource)}}>
     {/* <MdOutlineDeleteForever className="deleteLib ml-auto" onClick={()=> {delId(resource.id)}}/> */}
        <h2 className="h2CardRes">{resource.name}</h2>
            </div>   )}
                </div> 
          : null}

   <form className="addChallenge mb-[100px]"> 
    <span className={current==="LINK" ? "trChActive" : "trChNoactive"} onClick={() => setCurrent("LINK")}>LINK</span> 
    <span className={current==="HTML" ? "trChActive" : "trChNoactive"} onClick={() => setCurrent("HTML")}>HTML</span>
      <div className="addChallengeFlex mt-6">
         <div className="addChallengeLR">
    <div className="addCHInpts">
            <label for="resourceName">Resource Name</label>
            <input type="text" className="inputWidth" id="resourceName" value={formInputs.resourceName} placeholder="Enter resource Name" 
            onChange={(e) =>setFormInputs({...formInputs, resourceName: e.target.value})}/>
          </div>
<div className="addCHInpts">
            <label for="description">Description</label>
            <textarea type="text" className="inputWidth" id="description" value={formInputs.description} placeholder="Enter Description"
             onChange={(e) =>setFormInputs({...formInputs, description: e.target.value})}/>
           </div>

    </div>
        <div className="addChallengeLR">
        { current==="HTML" ? <div >
       <h4 className="trAttachment"> HTML </h4>
        <div className="trAttachmentDev mrAtt flex">
        <FileUploader handleChange={handleHtmlChange} name="file" types={fileTypes} />
          <Loader loading={htmlLoading} />
          {html && !htmlLoading ? <IoCheckmarkDoneCircleSharp style={{ width: '45px', height: '45px', marginLeft: '10px', color: 'green' }}/> : null}
        </div>
     </div>
:
    <div className="addCHInpts">
            <label for="link">Link</label>
            <input type="text" className="inputWidth" id="link" value={formInputs.link} placeholder="Enter Link"
             onChange={(e) =>setFormInputs({...formInputs, link: e.target.value})}/>
           </div> }
          </div>
</div>

        <div className="flex justify-center gap-x-4 mt-[25px]">
       <button onClick={handleAddRes} disabled={!isFormValid} className="add-plate w-[100px]">Add </button>
      <Link to={`/admin/tr/projects/main/${id}`}> <button onClick={successSaved} className="add-plate w-[100px]">Save</button> </Link>
        </div>
       </form> 
               { delOpen ? <div className="modal"> <div id="delPopup">
                   <button id="popIcon" onClick={()=>{setDelOpen(false)}}>
                   <FaRegWindowClose className="w-full h-full	"/>
                 </button>
                 <div id="helpText"><span >Do you want to delete this one?</span>
                  <p className="delResName">( {delOneId.name} )</p>
                  </div>
                 <div className="resYesNo">
                 <button className="yesorno" onClick={() => {confirmDel(delOneId.id)}}> Yes </button>
                 <button className="yesorno" onClick={()=>{setDelOpen(false)}}> No </button> 
                </div>
                   </div></div> : null}
    </div>
  );
};

export default EditResources;
